import { Breakpoint, getBreakpoint } from '@shared/Frontend/utils/breakpoints'
import { t } from 'i18next'
import { List, Map } from 'immutable'
import {
  AsyncState,
  initialRoute,
  IOWidget,
  loadingAsyncState,
  none,
  Option,
  unloadedAsyncState,
  Updater,
  Widget
} from 'widgets-for-react'
import { CookiebarState } from '../legacy/public_site/components/cms/blocks/cookiebar/cookiebar.types.mod'
import { make_empty_cookie_state_zero } from '../legacy/public_site/components/cms/blocks/cookiebar/cookiebar.widget.mod'
import { Page, TemplateState } from '../legacy/public_site/components/cms/page/types.gen'
import { BatchRequestResponse } from '../legacy/public_site/components/http_batch'
import { getPage } from '../legacy/public_site/components/public_site/application.mod'
import { pageDisplay } from '../legacy/public_site/components/public_site/blocks/renderer.mod'
import { SearchOverviewState } from '../legacy/public_site/components/public_site/custom_pages/search_overview/search_overview.state'
import { UpdateOverviewState } from '../legacy/public_site/components/public_site/custom_pages/update_overview'
import { page } from '../legacy/public_site/components/public_site/templates/drupal_page.mod'
import { FooterState } from '../legacy/public_site/components/public_site/templates/footer.mod'
import { getFooterConfig } from '../legacy/public_site/components/public_site/utils/custom_api'

import { defaultLanguage, getLangFromUrl } from '../legacy/public_site/components/public_site/utils/history.mod'
import { Debounced } from '../legacy/public_site/custom_components/debounce/debounce.state'
import { mkSearchSelectState } from '../legacy/public_site/components/public_site/custom_pages/search_overview/search_overview.state'
import {
  initialServerRedirectState,
  ServerRedirectState
} from '../legacy/public_site/custom_components/serverRedirect.widget'
import { initialSiteheaderState, SiteheaderState } from './siteheader/siteheader.state'
import { pages } from './utils'

export type RootState = {
  state: PublicSiteState
  current_widget: Option<IOWidget<PublicSiteState, Updater<PublicSiteState>>>
  page: Pages
}

export type PublicSiteState = {
  siteheader: SiteheaderState
  footer: FooterState
  batch_get_header_footer: AsyncState<BatchRequestResponse[]> //body + get_language
  year: number
  cookiestate: CookiebarState
  serverRedirectState: ServerRedirectState
  breakpoint: Breakpoint
  viewportWidth: number
  update_overview: UpdateOverviewState
  search_overview: SearchOverviewState
  page: TemplateState & {
    display: (placeholder: Widget<Updater<TemplateState>>) => (state: PublicSiteState) => Widget<Updater<TemplateState>>
    pageDisplay: (
      public_state: PublicSiteState,
      set_public_site_state: (output: Updater<PublicSiteState>) => void
    ) => IOWidget<TemplateState, Updater<TemplateState>>
    get_page: (slug: string) => AsyncState<Page>
  }
}

export type Pages =
  | { kind: 'update_overview'; page: number; lang: string }
  | { kind: 'search_overview'; page: number; lang: string; query: string; type: string }
  | { kind: 'styleguide' }
  | { kind: '404' }
  | { kind: 'page'; slug?: string }

export const initialRootState = (): RootState => {
  const updater = initialRoute(pages)
  return updater({
    current_widget: none(),
    page: { kind: '404' },
    state: {
      cookiestate: make_empty_cookie_state_zero(),
      batch_get_header_footer: unloadedAsyncState(),
      serverRedirectState: initialServerRedirectState(),
      breakpoint: getBreakpoint(),
      viewportWidth: window.innerWidth,
      page: {
        page: unloadedAsyncState(),
        images: Map(),
        blocks: Map(),
        pageDisplay,
        get_page: getPage,
        display: page(none())
      },
      siteheader: initialSiteheaderState,
      footer: {
        cols: unloadedAsyncState(), //loadingAsyncState(() => Api.loadFooter()),
        col_1: none(),
        col_2: none(),
        col_3: none(),
        privacyMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadPrivacyMenu())
        footerImage: loadingAsyncState(() => getFooterConfig(getLangFromUrl()))
      },
      year: new Date(Date.now()).getUTCFullYear(),
      update_overview: {
        kind: 'updates',
        overview_page: 0,
        get_updates: unloadedAsyncState(),
        get_searches: unloadedAsyncState(),
        get_tags: unloadedAsyncState(),
        sustainability_tags: unloadedAsyncState(),
        current_tags: List(),
        updates_jsx: none(),
        current_query: '',
        get_suggestions: unloadedAsyncState(),
        state: null
      },
      search_overview: {
        overview_page: 0,
        current_query: Debounced.clean(''),
        get_searches: unloadedAsyncState(),
        get_suggestions: unloadedAsyncState(),
        get_updates: unloadedAsyncState(),
        get_category_counts: unloadedAsyncState(),
        sortBy: 'relevance',
        pageTypeSelection: mkSearchSelectState(
          // These are availaible content types, it is not possible to get a list of types from drupal
          defaultLanguage != 'ru'
            ? [
                { label: t('Common:Search:Options:page'), value: 'page' },
                { label: t('Common:Search:Options:expertise'), value: 'expertise' },
                { label: t('Common:Search:Options:update'), value: 'update' },
                { label: t('Common:Search:Options:project'), value: 'project' },
              ]
            : [
                { label: t('Common:Search:Options:expertise'), value: 'expertise' },
                { label: t('Common:Search:Options:project'), value: 'project' },
              ],
          undefined,
          t('Common:Select')
        )
      }
    }
  })
}
